// extracted by mini-css-extract-plugin
export var typingIndicator = "_oy-0";